import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const GoogleAccountIntegrationBannerGate = React.lazy(
  () => import("./GoogleAccountIntegrationBanner.gate")
);

const GoogleAccountIntegrationBannerLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <GoogleAccountIntegrationBannerGate />
  </React.Suspense>
);

export default () => <GoogleAccountIntegrationBannerLoadable />;
